"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
const processSteps = [{
  num: "01",
  title: "Discovery",
  description: "We align with your investment goals and gather essential property details to tailor our approach."
}, {
  num: "02",
  title: "Inspection",
  description: "Comprehensive property evaluation to determine optimal rental value and identify necessary improvements."
}, {
  num: "03",
  title: "Marketing",
  description: "High-quality photography and strategic syndication across top Kansas City rental platforms."
}, {
  num: "04",
  title: "Placement",
  description: "Rigorous background, credit, and eviction screening to secure reliable, long-term tenants."
}, {
  num: "05",
  title: "Management",
  description: "Ongoing rent collection, 24/7 maintenance coordination, and transparent financial reporting."
}];
export default function TheManagementProcess() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-management-process" className="py-24 relative overflow-hidden !bg-[rgba(207,197,179,1)]">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,var(--color-muted)_0%,transparent_40%)] opacity-50 pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-foreground mb-4">
            Our Proven Management Process
          </h2>
          <p className="text-lg text-muted-foreground">
            A streamlined, transparent approach designed to maximize your property's performance and give you peace of mind in the Kansas City market.
          </p>
        </div>

        <div ref={ref} className={`relative transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-px bg-border z-0" />
          
          {}
          <div className="lg:hidden absolute left-[39px] md:left-[47px] top-8 bottom-8 w-px bg-border z-0" />

          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-6">
            {processSteps.map((step, i) => <div key={step.num} data-index={i} className="relative z-10 flex lg:block">
                {}
                <div className="lg:hidden flex-shrink-0 w-20 md:w-24 flex justify-center pt-6">
                  <div className="bg-background py-2">
                    <span className="text-4xl md:text-5xl font-black text-transparent [-webkit-text-stroke:1.5px_var(--color-primary)]">
                      {step.num}
                    </span>
                  </div>
                </div>

                <Card className="text-card-foreground flex flex-col gap-6 rounded-xl py-6 flex-1 backdrop-blur-md border-border/60 shadow-lg transition-all duration-300 group !bg-[rgba(255,255,255,1)] hover:shadow-xl lg:h-full">
                  <CardHeader className="pb-4 lg:pt-8">
                    {}
                    <div className="hidden lg:block mb-6 bg-background w-fit pr-4">
                      <span className="text-6xl font-black [-webkit-text-stroke:2px_var(--color-primary)] group-hover:[-webkit-text-stroke:2px_var(--color-secondary)] transition-all duration-300 !font-sans !text-[rgba(111,125,90,0)]">
                        {step.num}
                      </span>
                    </div>
                    <CardTitle className="text-xl font-semibold !text-[rgba(47,42,38,1)] md:text-2xl">
                      {step.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground leading-relaxed">
                      {step.description}
                    </p>
                  </CardContent>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}